import { render, staticRenderFns } from "./ChecklistFloatFieldModule.vue?vue&type=template&id=dc0f9ae8&scoped=true"
import script from "./ChecklistFloatFieldModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChecklistFloatFieldModule.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0f9ae8",
  null
  
)

export default component.exports